import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { PanelAPI, SocialNetworksAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import BaseController from '../BaseController';
import ConfigurationService from '../../services/configuration-services';

@Controller({ fragment: 'footer', component: 'footer-layout' })
export default class FooterController extends BaseController {

  @Inject('phone-panel')
  phoneTitlePanel: PanelAPI;

  @Inject('email-panel')
  emailTitlePanel: PanelAPI;

  @Inject('address-text')
  addressText: TextAPI;

  @Inject('email-text')
  emailText: TextAPI;

  @Inject('phone-text')
  phoneText: TextAPI;

  @Inject('social-networks-footer')
  social: SocialNetworksAPI;

  @OnMount({ target: 'footer-layout' })
  onMountFooterLayout(): void {
    const { social, emailText, emailTitlePanel, phoneText, phoneTitlePanel, addressText } = this;
    ConfigurationService.getConfigurationData().then(layoutData => {

      if (layoutData.dsLinkFacebook != null) {
        social.setFacebook(layoutData.dsLinkFacebook);
      }
      if (layoutData.dsLinkInstagram != null) {
        social.setInstagram(layoutData.dsLinkInstagram);
      }
      if (layoutData.dsLinkTwitter != null) {
        social.setTwitter(layoutData.dsLinkTwitter);
      }
      if (layoutData.dsLinkYoutube != null) {
        social.setYoutube(layoutData.dsLinkYoutube);
      }
      if (layoutData.dsLinkLinkedin != null) {
        social.setLinkedin(layoutData.dsLinkLinkedin);
      }
      if (layoutData.dsEmailRodape != null) {
        emailText.setValue(layoutData.dsEmailRodape);
      } else {
        emailTitlePanel.setVisible(false);
      }
      if (layoutData.nrFoneContato != null) {
        phoneText.setValue(layoutData.nrFoneContato);
      } else {
        phoneTitlePanel.setVisible(false);
      }
      if (layoutData.dsEndereco != null) {
        addressText.setValue(layoutData.dsEndereco);
      }
    });
  }
}